import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const AttachmentInfoContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const Cont = styled.div((props)=>({
  display:'flex',
  flexDirection:'column',

  '.title':{
    fontWeight:'bold',
    marginTop:'1rem'
  }
}))

export const FileCont = styled.div((props)=>({
  display:'flex',
  marginTop:'0.5rem',

  '>div:first-child':{
    flex:1
  },
  '>div:last-child':{
    flex:4
  },

  '.titleFile':{
    fontWeight:'normal',
    display:'flex',
    justifyContent:'flex-end'
  },

  '.fileItem':{
    fontWeight:'normal',
    display:'flex',
    flexDirection:'column',
    'button':{
      marginTop:'0.1rem'
    }
  },

  '.fileName':{
    display:'flex',
    justifyContent:'flex-start',
    wordBreak: 'break-all',
  },

  '.noFile':{
    fontStyle:'italic',
    marginLeft: '1rem'
  },

  '.button':{
    marginLeft:'1rem'
  }
}))

export const AttachmentFormContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  marginTop:'1rem',
  
  '>div:last-child':{
    marginRight:'0 !important'
  },

  '.sectionLeft': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginRight: '15px',
  },

  '.sectionRight': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  '.fileInput':{
    width:'100%'
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',
  },
})

export const FileUploadCellContainer = styled.div((props)=>({
  display: 'flex',
  minHeight: '40px',
  border: `solid 1px ${v.borderFile}`,
  borderRadius: '5px',
  boxShadow: `${v.boxShadow}`,
  alignItems: 'center',
  marginTop: '1rem',
  width: '100%',
  justifyContent: 'space-between',
  background: `${props.deleted ? '#E73C3E' : '#8EDD65'}`,

  '& .left, & .right': {
    display: 'flex',
    alignItems: 'center',
  },

  '& .right': {
    justifyContent: 'flex-end'
  },

  '& .right button.ui.button': {
    marginLeft: '10px',
    marginRight: '0px',
    borderRadius: '0px 5px 5px 0px',
    background: 'transparent',
    borderLeft: `solid 1px ${v.borderFile}`,
  },

  '& .right button.ui.button svg path': {
    color: `${v.textRed}`,
  },

  '.iconContent': {
    display: 'flex',
    height: 'auto',
    width: '40px',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '.iconContent svg path': {
    color: `${props.deleted ? '#fff' : v.ezMainColor}`,
  },

  '.titleContent': {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    fontSize: '12px',
  },

  '.fileNameContent': {
    color: `${props.deleted ? '#fff' : v.textBlack}`,
    textDecoration: `${props.deleted ? 'line-through' : 'none'}`,
    wordBreak:'break-all'
  },

  '.fileSizeContent':{
    whiteSpace: 'nowrap',
    color: `${props.deleted ? '#fff' : v.textBlack}`,
    textDecoration: `${props.deleted ? 'line-through' : 'none'}`,
    paddingLeft:'0.5rem'
  }
}))

export const AttachmentContainer2 = styled.div({
  display: 'flex',
})

export const Cont2 = styled.div(props => ({
  display:'flex',
  flex:1,
  flexDirection:'column',
}))

export const SContDetail = styled.div(props => ({
  display: 'flex',
  marginTop: props.sub ? '0' : '1rem',

  '&>div:first-child': {
    marginLeft: 0,
    flex: 1
  },

  '>div:first-child .toleft': {
    marginLeft: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  '&>div': {
    marginLeft: '1rem',
    flex: 1
  }
}))

export const AttachmentGroup = styled.div({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  marginTop: '15px',

  '&:first-child': {
    marginTop: '0px',
  },

  'div.attachmentLabel': {
    display: 'flex',
    fontWeight: 'bold',
    minWidth: '100px',
    height: '40px',
    alignItems: 'center',
  },

  'div.attachmentBy': {
    display: 'flex',
    minWidth: '150px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginRight: '5px',

    span: {
      fontWeight: 'bold',
    },
  },
})

export const AttachmentContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  'div:first-child>div': {
    marginTop: '0px',
  },

  'div>div': {
    marginTop: '5px',
  }
})

export const FieldFileInput = styled.div((props)=>({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  marginRight: '1rem',
  
  '.oldFile':{
    '.fileUploadCellContainer':{
      //background: '#8EDD65 !important',
      //border: 'none !important',
    }
  },

  '@media only screen and (min-width: 600px)': {
    width: '45%',
  },

  '@media only screen and (min-width: 769px)': {
    width: '31%',
  },
}))